
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    modelValue: {
      type: [Number, String],
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    max: {
      type: [Number, String],
      required: false,
    },
    min: {
      type: [Number, String],
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    maxWidth: {
      type: String,
      required: false,
      default: "initial",
    },
  },
  setup(_props, { emit }) {
    const onInput = async (event: Event) => {
      const input = event.target as HTMLInputElement;

      if (!input.value || input.value === "") {
        emit("update:modelValue", undefined);
        return;
      }

      emit("update:modelValue", Number(input.value));
    };

    return { onInput };
  },
});
